import i18n from "../i18n";
import { getPreferredTimeZone } from "./userPreferences";

const LOCALES = { es: "es-DO", en: "en-US" };

export function getActiveLocale(language = i18n.resolvedLanguage) {
  return LOCALES[String(language || "es").split("-")[0]] || LOCALES.es;
}

export function formatNumber(value, options = {}) {
  return new Intl.NumberFormat(getActiveLocale(), options).format(
    Number(value || 0)
  );
}

export function formatCurrency(value, options = {}) {
  const { currency = "DOP", ...rest } = options;
  return new Intl.NumberFormat(getActiveLocale(), {
    style: "currency",
    currency,
    ...rest,
  }).format(Number(value || 0));
}

export function formatPercent(value, options = {}) {
  return new Intl.NumberFormat(getActiveLocale(), {
    style: "percent",
    maximumFractionDigits: 1,
    ...options,
  }).format(Number(value || 0));
}

export function formatDate(value, options = {}) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value || "");
  return new Intl.DateTimeFormat(getActiveLocale(), {
    timeZone: getPreferredTimeZone(),
    dateStyle: "short",
    ...options,
  }).format(date);
}

export function formatDateTime(value, options = {}) {
  return formatDate(value, {
    dateStyle: "short",
    timeStyle: "short",
    ...options,
  });
}
